import { render, staticRenderFns } from "./Record_ticket.vue?vue&type=template&id=d6d3c53c&"
import script from "./Record_ticket.vue?vue&type=script&lang=js&"
export * from "./Record_ticket.vue?vue&type=script&lang=js&"
import style0 from "./Record_ticket.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports